import { createContext } from "react";

import { AlertOptions } from "../model/types/alert";

export enum AlertTheme {
  SUCCESS = "Success",
  ERROR = "Error",
}

export interface AlertContextPayload {
  showAlert: (alert: AlertOptions) => void;
}

export const AlertContext = createContext<AlertContextPayload>({} as AlertContextPayload);
